<template>
  <main class="page white-page code-page">
    <h1>获取验证码</h1>
    <p class="desc">验证码已经发送到您的手机</p>
    <p class="tel"><span>+86</span> {{ tel }}</p>
    <div class="code-label">
      <span>6位数字验证码</span
      ><button type="button" @click="reset">
        {{ countdown ? `重新获取(${countdown}s)` : "重新获取" }}
      </button>
    </div>
    <div class="code-entry">
      <input
        v-model="code"
        class="code-input"
        inputmode="numeric"
        maxlength="6"
        autocomplete="one-time-code"
        aria-label="6位数字验证码"
        @focus="isFocused = true"
        @blur="isFocused = false"
      />
      <div class="code-slots" aria-hidden="true">
        <span
          v-for="index in 6"
          :key="index"
          class="code-underline"
          :class="{
            active:
              index <= code.length || (isFocused && index === code.length + 1),
            cursor: isFocused && index === code.length + 1,
          }"
        >
          {{ code[index - 1] || "" }}
        </span>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "MessageValidateCode",
  data: () => ({
    tel: sessionStorage.getItem("loginTel") || "",
    code: "",
    isFocused: false,
    countdown: 0,
    timer: null,
  }),
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    code(value) {
      const digits = value.replace(/\D/g, "").slice(0, 6);
      if (digits !== value) {
        this.code = digits;
        return;
      }
      if (value.length === 6) this.$router.push("/certification");
    },
  },
  methods: {
    reset() {
      if (this.countdown) return;
      this.countdown = 10;
      this.timer = setInterval(() => {
        this.countdown -= 1;
        if (!this.countdown) clearInterval(this.timer);
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.code-page {
  min-height: 100vh;
  padding: 40px 25px;
  background-image: url("~@/assets/images/beijing@2x.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
h1 {
  margin: 0 0 10px;
  font-size: 26px;
  font-weight: bold;
}
.desc {
  margin: 0 0 8px;
  font-size: 15px;
}
.tel {
  margin: 0 0 50px;
  font-size: 18px;
}
.tel span {
  margin-right: 8px;
}
.code-label {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  font-size: 15px;
}
.code-label button {
  padding: 0;
  border: 0;
  background: transparent;
  color: #f9a934;
}
.code-entry {
  position: relative;
}
.code-input {
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 48px;
  border: 0;
  opacity: 0;
  font-size: 20px;
  font-weight: bold;
}
.code-slots {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
}
.code-underline {
  width: 100%;
  height: 48px;
  border-bottom: 2px solid #d6d7d6;
  font-size: 26px;
  font-weight: 500;
  line-height: 52px;
  text-align: center;
}
.code-underline.active {
  border-bottom-color: #f1daca;
}
.code-underline.cursor::after {
  display: inline-block;
  width: 1px;
  height: 16px;
  background: #000;
  vertical-align: 1px;
  content: "";
  animation: code-cursor 1s steps(1) infinite;
}
@keyframes code-cursor {
  50% {
    background: #fff;
  }
}
</style>
